import api from "./api";

export async function getContactProfils(): Promise<any | null> {
    return await api
        .get("/api/contact-profile/")
        .then((response) => {
            if (response.status >= 400) {
                throw new Error(JSON.stringify(response));
            }
            return response.data;
        })
        .catch((e: Error) => {
            const error = e.message ? e : JSON.parse(e.message);

            if (error.response) {
                return error.response.data;
            }
            return error;
        });
}

export async function getContactsOfEstablishement(
    establishementId: number
): Promise<any | null> {
    return await api
        .get("/api/contact/?establishment_id=" + establishementId)
        .then((response) => {
            if (response.status >= 400) {
                throw new Error(JSON.stringify(response));
            }
            return response.data;
        })
        .catch((e: Error) => {
            const error = e.message ? e : JSON.parse(e.message);

            if (error.response) {
                return error.response.data;
            }
            return error;
        });
}

export async function putContact(
    contactId: number,
    contact: any
): Promise<any | null> {
    return await api
        .put("/api/contact/" + contactId, contact)
        .then((response) => {
            if (response.status >= 400) {
                throw new Error(JSON.stringify(response));
            }
            return response.data;
        })
        .catch((e: Error) => {
            const error = e.message ? e : JSON.parse(e.message);

            if (error.response) {
                return error.response.data;
            }
            return error;
        });
}
